export function createPageUrl(pageName: string) {
    const kebab = pageName
        .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
        .toLowerCase();
    return '/' + kebab.replace(/ /g, '-');
}